export default (el: HTMLElement) => {
  const klaviyoStarRatingWidget = document.querySelector(
    ".klaviyo-star-rating-widget"
  );

  if (klaviyoStarRatingWidget) {
    klaviyoStarRatingWidget.remove();

    const productFormReviews = document.querySelector(".product-form__reviews");

    if (productFormReviews) {
      productFormReviews.appendChild(klaviyoStarRatingWidget);
    }
  }
};
